var MARKETING_DOCUMENTS_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
};
export var getMarketingDocumentsApiConfig = function () {
    return MARKETING_DOCUMENTS_API_CONFIG;
};
export var setMarketingDocumentsApiConfig = function (config) {
    MARKETING_DOCUMENTS_API_CONFIG.baseUrl = config.baseUrl;
    MARKETING_DOCUMENTS_API_CONFIG.marketLocale = config.marketLocale;
};
